import React from 'react';
import { Box, FormControl, FormHelperText, FormLabel, Grid, MenuItem, Select } from '@mui/material';
import { useFormikContext } from 'formik';
import { RelationshipContactSelect } from '@/components/selects/RelationshipContactSelect';
import FolioCheckbox from '@/components/FolioCheckbox';
import { RELATIONSHIP_CONTACT_TYPE_OPTIONS } from '@/utils/relationshipContactOptions';
import { SEARCH_RELATIONSHIP_CONTACT_HELP_TEXT } from '@/utils/helperText';
import CompanyTextField from '../CompanyTextField';

const PrimaryContactFields = ({ disabled = false }) => {
	const { values, touched, errors, getFieldProps, setFieldValue, setFieldTouched } =
		useFormikContext();

	return (
		<>
			<FormLabel required>Primary contact</FormLabel>
			<Box sx={{ mb: 2, mt: 1 }}>
				<FolioCheckbox
					checked={Boolean(values.isExistingRelationshipContact)}
					label='Select existing contact'
					disabled={disabled}
					onChange={(event) => {
						const checked = event.target.checked;
						setFieldValue('isExistingRelationshipContact', checked);
						if (checked) {
							setFieldValue('firstName', '');
							setFieldValue('lastName', '');
							setFieldValue('primaryEmail', '');
							setFieldValue('mobile', '');
							setFieldValue('relationshipType', 'other');
						} else {
							setFieldValue('existingRelationshipContact', null);
						}
					}}
				/>
			</Box>
			{values.isExistingRelationshipContact ? (
				<Box>
					<FormLabel required>Search contact</FormLabel>
					<RelationshipContactSelect
						disabled={disabled}
						required
						error={Boolean(
							touched.existingRelationshipContact && errors.existingRelationshipContact,
						)}
						value={values.existingRelationshipContact}
						onChange={(individual) => {
							setFieldValue('existingRelationshipContact', individual);
							setFieldTouched('existingRelationshipContact', true, false);
						}}
					/>
					{touched.existingRelationshipContact && errors.existingRelationshipContact && (
						<FormHelperText error>{errors.existingRelationshipContact}</FormHelperText>
					)}
					<FormHelperText>{SEARCH_RELATIONSHIP_CONTACT_HELP_TEXT}</FormHelperText>
				</Box>
			) : (
				<Grid container spacing={2}>
					<Grid size={{ xs: 12, sm: 6 }}>
						<CompanyTextField
							name='firstName'
							label='First name'
							required
							disabled={disabled}
						/>
					</Grid>
					<Grid size={{ xs: 12, sm: 6 }}>
						<CompanyTextField name='lastName' label='Last name' disabled={disabled} />
					</Grid>
					<Grid size={{ xs: 12, sm: 6 }}>
						<CompanyTextField name='primaryEmail' label='Email' required disabled={disabled} />
					</Grid>
					<Grid size={{ xs: 12, sm: 6 }}>
						<CompanyTextField name='mobile' label='Mobile' disabled={disabled} />
					</Grid>
					<Grid size={{ xs: 12, sm: 6 }}>
						<FormControl fullWidth>
							<FormLabel>Type</FormLabel>
							<Select disabled={disabled} {...getFieldProps('relationshipType')}>
								{RELATIONSHIP_CONTACT_TYPE_OPTIONS.map((option) => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			)}
		</>
	);
};

export default PrimaryContactFields;
